module.exports = __webpack_public_path__ + "static/media/DI.30fa74e9.png";